<script setup lang="ts">

import Checkbox from "~/components/UI/btn/Checkbox.vue";
import {User} from "~/api/User";

defineEmits(['use']);

const bonuses = ref(0);
User.getBonuses().then(b => bonuses.value = b);
</script>

<template>
    <Checkbox
            v-if="bonuses > 0"
            :label="`Использовать бонусы ${bonuses}`"
            @change="$emit('use', $event ? bonuses : 0)"
    />
</template>

<style scoped>

</style>